export default "__VITE_ASSET__Do1TryLS__"